import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { DictionaryEntry } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { DocumentTemplateDetails } from '../../document-template-administration-model';

@Component({
    selector: 'app-template-details',
    templateUrl: './template-details.component.html',
    styleUrls: ['./template-details.component.scss'],
    standalone: false
})
export class TemplateDetailsComponent implements OnInit {

  details: DocumentTemplateDetails = new DocumentTemplateDetails();

  detailsFormGroup: FormGroup;

  @Input() set template(details: DocumentTemplateDetails) {
    this.details = details;

    const values = {
      titlePattern: this.details.titlePattern,
    };
    this.detailsFormGroup.reset(values);
  }

  constructor(public translationService: TranslationService) {
    this.initializeDetailsForm();
  }

  ngOnInit(): void {
  }

  public onDataDictionaryChanged(dictionaryEntry: DictionaryEntry) {
    // Object neu erzeugen damit change detection und somit überstzungspipe reagieren
    this.details.name = new DictionaryEntry(dictionaryEntry);
    this.details.dirty = true;
    this.details.validate();
  }

  private initializeDetailsForm() {
    this.detailsFormGroup = new FormGroup({
      titlePattern: new FormControl('', [Validators.required]),
    });

    this.detailsFormGroup.valueChanges.subscribe(
      values => {
        if (this.detailsFormGroup.dirty) {
          const v = this.detailsFormGroup.getRawValue();
          this.details.titlePattern = v.titlePattern;
          this.details.dirty = true;
          this.details.validate();
        }
      }
    );
  }

}
